import React, { useEffect, useState } from 'react';
import { Stack } from 'react-bootstrap';

import { usePreferenceJobsQuery } from 'services';
import PaginationBox from 'components/PaginationBox';
import JobListingBox from 'components/Common/Jobs/JobListingBox';
import { dataLimits } from 'constants/index';
import useTranslate from 'hooks/useTranslate';
import './styles.scss';
import useLocalizationStore from 'store/localization';
import { setIsLoading } from 'store/common';
import { useNavigate } from 'react-router-dom';

const MyMatches: React.FC = () => {
	const { translate } = useTranslate();
	const navigate = useNavigate();
	const { activeLanguage }: any = useLocalizationStore((state) => state);
	const [currentPage, setCurrentPage] = useState(1);
	const [orderBy, setOrderBy] = useState('createdAt');
	const [order, setOrder] = useState('DESC');

	const [jobs, setJobs] = useState([]);
	const [meta, setMeta] = useState({});

	const queryOptions = `limit=${dataLimits?.myMatchesJobs}&page=${currentPage}&orderBy=${orderBy}&order=${order}`;
	const { data = {}, refetch, isPending } = usePreferenceJobsQuery(queryOptions);

	useEffect(() => {
		if (!isPending) {
			if (data?.success) {
				const { docs = [], meta = {} } = data?.data || {};
				setJobs(docs || []);
				setMeta(meta || {});
			} else {
				setJobs([]);
				setMeta({});
			}
		}
	}, [data, isPending]);

	useEffect(() => {
		setIsLoading(isPending);
	}, [isPending, navigate]);

	useEffect(() => {
		refetch();
	}, [currentPage, orderBy, order, activeLanguage]);

	return (
		<section className="applied-jobs">
			<div className="d-flex flex-column flex-lg-row gap-4">
				<div className="right-area flex-1 d-flex flex-column">
					<div className="white-box bg-white">
						<Stack className="gap-3 gap-md-4">
							<div className="jobs-filter d-flex align-items-center justify-content-between">
								<p className="fw-semibold mb-0">{translate('Common.suggestedJobs')}</p>
							</div>
							{jobs?.length > 0 ? (
								jobs.map((job: any, index: number) => (
									<JobListingBox
										job={job}
										key={index}
										enableFavBtn={!job?.isJoobleJob}
										enableApplyBtn={!job?.isJoobleJob}
									/>
								))
							) : (
								<Stack className="posted-job-box">
									<p className="mb-0">{translate('Common.noJobsFound')}</p>
								</Stack>
							)}
						</Stack>

						{meta?.totalDocs > meta?.limit && (
							<PaginationBox
								totalData={meta?.totalDocs}
								limit={meta?.limit}
								page={currentPage}
								setCurrentPage={setCurrentPage}
							/>
						)}
					</div>
				</div>
			</div>
		</section>
	);
};

export default MyMatches;
